//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RewardBlock',
  components: '',
  props: [
    'discountType',
    'freeShipping',
    'index',
    'requirementType',
    'reward',
    'currencySymbol'
  ],
  data () {
    return {
      minimumRequirement: 0,
      settings: []
    }
  },
  methods: {
    toggleStatus() {
      this.reward.enable = !this.reward.enable
      if(this.$parent.shipping.tier === this.index + 1) {
        this.$parent.shipping.tier = 1;
        this.$parent.shipping.enable = false;
      }
      if(!this.reward.enable) {
        if(this.index === 0) {
          this.$parent.rewards[1].enable = false;
          this.$parent.rewards[2].enable = false;
          this.$parent.rewards[3].enable = false;
        }
        if(this.index === 1) {
          this.$parent.rewards[2].enable = false;
          this.$parent.rewards[3].enable = false;
        }
        if(this.index === 2) {
          this.$parent.rewards[3].enable = false;
        }
      }
    }
  },
  mounted () {
  }
}
